import { useState } from "react";

const F = {
  "2xs": 10, xs: 12, sm: 13, md: 14, lg: 15, xl: 20,
};

const ACTION_LABEL = {
  in_spacy:  "Hablando con SpaCy",
  studying:  "Estudiando",
  in_quiz:   "En quiz",
  playing:   "Jugando",
  idle:      "Navegando",
};

export default function LiveUsersPanel({ users = [], t, HI, dark, bp }) {
  const [expanded, setExpanded] = useState(true);
  const sep = dark ? "rgba(255,255,255,.05)" : "rgba(0,0,0,.05)";

  // 🛑 EXTIRPADO: Ya no regresamos 'null'. El panel SIEMPRE se va a renderizar.
  // if (users.length === 0) return null;

  return (
    <div style={{
      background: t.bg,
      borderRadius: 16,
      border: `1px solid ${HI}22`,
      boxShadow: `${t.nmd}, 0 0 0 1px ${HI}18`,
      overflow: "hidden",
      marginBottom: 16 // Margen para separarlo de los KPIs y del resto de abajo
    }}>
      {/* Header del Radar */}
      <div
        onClick={() => setExpanded(p => !p)}
        style={{
          display: "flex", alignItems: "center", gap: 10,
          padding: "12px 16px", cursor: "pointer",
          background: dark ? `${HI}08` : `${HI}05`,
          borderBottom: expanded ? `1px solid ${HI}18` : "none",
        }}
      >
        {/* Pulso vivo (Gris si está vacío, Verde si hay alguien) */}
        <div style={{ position: "relative", width: 10, height: 10, flexShrink: 0 }}>
          <div style={{
            position: "absolute", inset: 0, borderRadius: "50%",
            background: users.length > 0 ? "#10b981" : t.tx3,
            boxShadow: dark && users.length > 0 ? "0 0 6px #10b981" : "none",
            animation: users.length > 0 ? "pls 2s infinite" : "none",
          }}/>
        </div>

        <span style={{ fontSize: F.sm, fontWeight: 800, color: t.tx }}>
          Radar de Usuarios (Live)
        </span>

        <span style={{
          fontSize: F.xs, fontWeight: 900, padding: "2px 8px",
          borderRadius: 50, background: `${HI}18`, color: HI,
          fontFamily: "monospace",
        }}>
          {users.length}
        </span>

        <span style={{ marginLeft: "auto", fontSize: F.sm, color: t.tx2 }}>
          {expanded ? "▲" : "▼"}
        </span>
      </div>

      {/* Lista de usuarios o Estado Vacío */}
      {expanded && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          
          {/* 🔥 NUEVO: Qué mostrar si no hay nadie conectado */}
          {users.length === 0 ? (
            <div style={{ padding: "30px 16px", textAlign: "center", color: t.tx2 }}>
              <div style={{ fontSize: 24, marginBottom: 8, opacity: 0.5 }}>📡</div>
              <div style={{ fontSize: F.sm, fontWeight: 600 }}>Radar Activo</div>
              <div style={{ fontSize: F.xs, marginTop: 4 }}>Esperando señales de alumnos en la plataforma...</div>
            </div>
          ) : (
            /* Mostrar la lista si SÍ hay usuarios */
            users.map((u, i) => (
              <UserRow
                key={u.id}
                u={u}
                t={t}
                dark={dark}
                sep={sep}
                isLast={i === users.length - 1}
                bp={bp}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
}

// ... (Aquí abajo mantén la función UserRow exactamente como la tenías) ...
function UserRow({ u, t, dark, sep, isLast, bp }) {
  const isVeryRecent = u.seconds_ago < 35;

  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 12,
      padding: "10px 16px",
      borderBottom: isLast ? "none" : `1px solid ${sep}`,
      background: isVeryRecent
        ? (dark ? "rgba(16,185,129,.03)" : "rgba(16,185,129,.02)")
        : "transparent",
    }}>
      {/* Avatar / iniciales */}
      <div style={{ position: "relative", flexShrink: 0 }}>
        <div style={{
          width: 34, height: 34, borderRadius: 10,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: F.xs, fontWeight: 800,
          background: `${u.pageColor}18`, color: u.pageColor,
          boxShadow: `0 0 0 1px ${u.pageColor}33`,
        }}>
          {(u.name || "?").split(" ").map(p => p[0]).join("").slice(0, 2).toUpperCase()}
        </div>
        {/* Dot vivo */}
        <div style={{
          position: "absolute", top: -2, right: -2,
          width: 8, height: 8, borderRadius: "50%",
          background: isVeryRecent ? "#10b981" : "#f59e0b",
          boxShadow: dark && isVeryRecent ? "0 0 5px #10b981" : "none",
          animation: isVeryRecent ? "pls 2s infinite" : "none",
        }}/>
      </div>

      {/* Info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          display: "flex", alignItems: "center", gap: 6, marginBottom: 3,
        }}>
          <span style={{
            fontSize: F.sm, fontWeight: 700, color: t.tx,
            overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
          }}>
            {u.name}
          </span>
          <span style={{ fontSize: F.lg, flexShrink: 0 }}>{u.pageIcon}</span>
        </div>

        <div style={{
          fontSize: F.xs, color: t.tx2,
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
        }}>
          <span style={{ color: u.pageColor, fontWeight: 700 }}>{u.pageLabel}</span>
          {u.section && u.section !== "—" && (
            <span> · {u.section}</span>
          )}
        </div>
      </div>

      {/* Tiempo + acción */}
      <div style={{ textAlign: "right", flexShrink: 0 }}>
        <div style={{
          fontSize: F.xs, fontWeight: 700,
          color: isVeryRecent ? "#10b981" : "#f59e0b",
          fontFamily: "monospace",
          marginBottom: 2,
        }}>
          {u.ago}
        </div>
        {!bp?.xs && (
          <div style={{
            fontSize: F["2xs"], color: t.tx2,
            textTransform: "uppercase", letterSpacing: ".06em",
          }}>
            {ACTION_LABEL[u.action] || u.action}
          </div>
        )}
      </div>
    </div>
  );
}